import { useEffect } from 'react';

/**
 * Changes the title of page appending '- Clearcover' to the title given.
 * If the title is an empty string then is will display 'Clearcover'.
 * Returns to 'Clearcover' on dismount of component.
 * @param title Title to be used
 */
export const useTitle = (title: string) => {
  useEffect(() => {
    document.title = `${title ? `${title} - ` : ''}Clearcover`;
    return () => {
      document.title = 'Clearcover';
    };
  }, [title]);
};
